import { render } from "./survivalCohorts.vue?vue&type=template&id=d3c0777c"
import script from "./survivalCohorts.vue?vue&type=script&lang=js"
export * from "./survivalCohorts.vue?vue&type=script&lang=js"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__